import { useSelector } from 'react-redux';

import {
  getBasketDuration,
  getCleaningPrestation,
  getCleaningPrestationOptions,
  getPrimaryAppointment,
  getPromotion,
  getUniverseRef,
  getZone,
} from '@front/common/src/ducks/customer/basket-selectors';

import { useGetPricesQuery } from '../queries/prices-queries';

import { useVersionedAt } from './use-versioned-at';

const useGetPrices = () => {
  const cleaningPrestation = useSelector(getCleaningPrestation);
  const cleaningPrestationOptions = useSelector(getCleaningPrestationOptions);
  const duration = useSelector(getBasketDuration);
  const primaryAppointment = useSelector(getPrimaryAppointment);
  const promotion = useSelector(getPromotion);
  const universeReference = useSelector(getUniverseRef);
  const zone = useSelector(getZone);

  const versionedAt = useVersionedAt();

  const { prices, pricesError } = useGetPricesQuery({
    duration,
    prestationReference: cleaningPrestation?.reference,
    prestationOptionsReferences: cleaningPrestationOptions?.map((option) => option.reference),
    promotionCode: promotion?.code,
    universeReference,
    zone,
    versionedAt,
    ...(primaryAppointment && { appointment: primaryAppointment }),
  });

  return { prices, pricesError };
};

export default useGetPrices;
